<template>
  <div class="score-list kolo">
    <span class="pic icon-kolo"></span>
    <p class="name"> Rezultati po kolima </p>

    <Loading :loadingState="loadingState">
        <ul v-if="results">
            <li v-for="data of results" v-bind:key="data.quizId">
                <span class="tag" v-if="data.played">{{ String(data.position).padStart(4, '0') }}</span>
                <p class="cf">
                    <span>
                        {{ data.name }}
                        <small class="month">{{ convertToMonth(data.startTime) }}</small>
                    </span>
                    <span v-if="data.played">
                        {{ data.points }}
                        <small>Bodova</small>
                    </span>
                    <span v-if="!data.played">
                        Nije igrao
                        <small></small>
                    </span>
                </p>
            </li>
        </ul>
        <NoResults v-if="results && results.length == 0" message="Korisnik ne postoji"></NoResults>
        <template v-slot:error>Došlo je do nepoznate pogreške</template>
    </Loading>
  </div>
</template>

<script>
import { TimeUtils } from '../utils/timeUtils'
import LoadingState from '../utils/loading/LoadingState'
import Loading from './common/Loading'
import NoResults from './common/error/NoResults'

export default {
    name: 'rezultati-kolo',
    data: function () {
        return {
            results: false,
            loadingState: LoadingState.LOADING
        }
    },
    methods: {
        async initialLoadData () {
            try {
                this.loadingState = LoadingState.LOADING
                this.results = await this.$db.results.getResultsForUid(this.uid)
                this.loadingState = LoadingState.SUCCESS
            } catch (error) {
                this.loadingState = LoadingState.ERROR
            }
        },
        convertToMonth (timestamp) {
            return TimeUtils.timesampToMonthName(timestamp)
        }
    },
    mounted () {
        try {
            this.initialLoadData()
        } catch (error) {

        }
    },
    computed: {
        uid () {
            return this.$route.params.uid
        }
    },
    components: {
        Loading,
        NoResults
    }
}
</script>

<style lang="scss" scoped>
.score-list.kolo {
  position: relative;
  box-shadow: 0px 9px 16px 0px rgba(0,0,0,0.16);
  background-color: #fff;
  border-radius: 5px;
  padding: 54px 12px 9px;
  margin-top: 30px;

  .pic {
    display: block;
    position: absolute;
    left: calc(50% - 40px);
    top: -30px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 5px solid #fff;
    background-color: #fff;
    background-position: 50%;
    background-size: cover;
  }
  .name {
    font-family: "axiforma";
    font-size: 16px;
    letter-spacing: .3px;
    color: #000;
    margin-bottom: 10px;
  }
  .select {
    display: block;
    width: 100%;
    appearance: none;
    outline: none;
    text-align: left;
    font-family: "axiforma";
    font-size: 16px;
    line-height: 22px;
    letter-spacing: .3px;
    color: #000;
    border: none;
    border-bottom: 1px solid #d7d7d7;
    margin-bottom: 20px;
    padding-left: 4px;
    background: url(~@/assets/img/icons/icon-carrot.png) 98% 50% no-repeat;
    background-size: 6px;
  }
  ul {
    position: relative;
    margin-top: 44px;

    li {
      position: relative;
      border-bottom: 1px solid #d6d6d6;
      padding: 0 0 8px 0px;
      margin-bottom: 12px;
    }
    .tag {
      box-shadow: 0px 9px 10px 0px rgba(255,0,92,0.25);
      background: linear-gradient(135deg, rgba(255,0,132,1) 0%, rgba(255,0,29,1) 100%);
      position: absolute;
      top: -2px;
      left: -34px;
      display: block;
      border-radius: 6px;
      min-width: 30px;
      font-size: 10px;
      text-align: center;
      color: #fff;
      font-weight: 800;
      letter-spacing: 1px;
      padding: 5px 3px;
    }
    p {
      font-family: "axiforma";
      color: #000;
      margin: 0;

      span:first-child {
        text-align: left;
        float: left;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: .3px;
      }
      span:last-child {
        text-align: right;
        float: right;
        font-family: "mPlus";
        font-size: 18px;
        line-height: 16px;
        letter-spacing: -.2px;

        small {
          text-transform: uppercase;
        }
      }
      small {
        display: block;
        font-weight: 600;
        color: #adadae;
        letter-spacing: .5px;
        font-size: 11px;
        line-height: 22px;
        &.month  {
            text-transform: capitalize;
        }
      }
    }
  }
}
</style>
